import React from "react";
import { useImmer } from "use-immer";
import { useMutation, useQueryClient } from "react-query";
import {
  createAssessmentSchedule,
  useAssessmentQuery,
  useAssessmentScheduleQuery,
  useAssessmentSlotQuery,
  useAssessmentResultQuery,
  GET_ASSESSMENT_LIST,
  GET_ASSESSMENT_SLOT,
} from "..";

export const useAssessment = ({ load = false, assessmentMasterId = null }) => {
  const queryClient = useQueryClient();

  const [isSlotInfoOpen, setIsSlotInfoOpen] = useImmer({
    type: "",
    isOpen: false,
    data: null,
  });
  const [selectedSlotId, setSelectedSlotId] = useImmer(null);
  const [assessmentPayload, setAssessmentPayload] = useImmer({
    assessmentId: null,
    scheduleMasterId: null,
  });
  const [scheduleId, setScheduleId] = useImmer(null);

  const isScheduleModalOpen =
    isSlotInfoOpen.isOpen && isSlotInfoOpen.type === "scheduleModal";

  const selectedProgram = JSON.parse(localStorage.getItem("selectedProgram"));
  const programId = selectedProgram?.id;
  const assessmentsQuery = useAssessmentQuery({
    load,
    programId,
  });

  const assessmentScheduleQuery = useAssessmentScheduleQuery({
    assessmentId: assessmentPayload.assessmentId,
    programId,
    scheduleMasterId: assessmentPayload.scheduleMasterId,
    isModalOpen: isScheduleModalOpen,
  });
  const assessmentSlotQuery = useAssessmentSlotQuery({
    scheduleId,
    isModalOpen: isScheduleModalOpen,
  });

  const assessmentResultQuery = useAssessmentResultQuery({
    assessmentMasterId,
  });

  const createSchedule = useMutation(createAssessmentSchedule, {
    onError: (e) => {
      setIsSlotInfoOpen((draft) => {
        draft.isOpen = true;
        draft.type = "unsuccess";
        draft.data = { ...draft.data, message: e.response.data.message };
        return draft;
      });
    },
    onSuccess: (e) => {
      queryClient.invalidateQueries([GET_ASSESSMENT_LIST, programId]);
      setIsSlotInfoOpen((draft) => {
        draft.isOpen = true;
        draft.type = "success";
        draft.data = { ...draft.data };
        return draft;
      });
    },
    onSettled: (e) => {},
  });

  const onAssessmentScheduleModal = ({
    assessmentId = null,
    scheduleMasterId = null,
  }) => {
    queryClient.removeQueries(GET_ASSESSMENT_SLOT);
    setScheduleId(null);
    setSelectedSlotId(null);
    setAssessmentPayload((draft) => {
      draft = {
        assessmentId,
        scheduleMasterId,
      };
      return draft;
    });
    setIsSlotInfoOpen((draft) => {
      draft.isOpen = true;
      draft.type = "scheduleModal";
      draft.data = null;
      return draft;
    });
  };

  return {
    selectedSlotId,
    setSelectedSlotId,
    scheduleId,
    setScheduleId,
    createSchedule,
    assessmentsQuery,
    assessmentScheduleQuery,
    assessmentSlotQuery,
    isSlotInfoOpen,
    setIsSlotInfoOpen,
    onAssessmentScheduleModal,
    assessmentResultQuery,
  };
};
